import { useUserSaveItem, useUserSaveType } from "@/app/layout/useUserSaves";
import PillButton from "@/app/shared/PillButton";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useRouter } from "next/navigation";
import { ParseUrl } from "@/actions/search/services/AdSearchUrlService";
import { GetPageTitle } from "@/actions/search/services/AdSearchTitleService";
import ClearIcon from "@mui/icons-material/Clear";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";

function GetSearchTitleFromPath(searchPath: string): string {
  const slugs = searchPath.split("/").filter((s) => s.length > 0);
  const searchRequest = ParseUrl(slugs);
  const searchTitle = GetPageTitle(searchRequest);
  return searchTitle;
}

export function SaveSearchButton({ searchPath }: { searchPath: string }) {
  const { isSaved, isDisabled, ToggleSave } = useUserSaveItem({
    type: "SEARCH",
    key: searchPath,
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { userSaves, RemoveUserSave } = useUserSaveType("SEARCH");
  const router = useRouter();
  const hasUserSaves = userSaves.length > 0;
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <PillButton
        sx={{
          backgroundColor: "grey.100",
        }}
        compact
        startIcon={isSaved ? <StarIcon /> : <StarBorderIcon />}
        endIcon={
          hasUserSaves && (
            <IconButton
              component='div'
              sx={{
                margin: -1,
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleOpenMenu(event);
              }}
            >
              <ArrowDropDownIcon />
            </IconButton>
          )
        }
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (isSaved) {
            handleOpenMenu(event);
          } else {
            await ToggleSave();
          }
        }}
        disabled={isDisabled}
        loading={isDisabled}
      >
        {isSaved ? "Saved" : "Save"}
      </PillButton>
      {hasUserSaves && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseMenu}
          anchorOrigin={{
            horizontal: "center",
            vertical: "bottom",
          }}
          transformOrigin={{
            horizontal: "center",
            vertical: "top",
          }}
        >
          {userSaves.map((save) => (
            <MenuItem
              key={save.key}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleCloseMenu();
                router.push("/for-sale/" + save.key);
              }}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: searchPath === save.key ? "bold" : "normal",
                  whiteSpace: "normal",
                  maxWidth: "300px",
                }}
              >
                {GetSearchTitleFromPath(save.key)}
              </Typography>
              <IconButton
                onClick={async (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  await RemoveUserSave(save.key);
                }}
                sx={{
                  margin: -1,
                }}
              >
                <ClearIcon />
              </IconButton>
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
}
